import { all, takeLatest } from 'redux-saga/effects'

import { loginSaga } from '../features/authentication/presentation/redux/saga/login-saga'
import { refreshJwtSaga } from '../features/authentication/presentation/redux/saga/refresh-jwt-saga'
import { LOGIN_REQUEST } from '../features/authentication/presentation/redux/types/login-types'
import { REFRESH_JWT_REQUEST } from '../features/authentication/presentation/redux/types/refresh-jwt-types'
import { createJourneySaga } from '../features/journey/presentation/redux/saga/create-journey-saga'
import { getJourneySaga } from '../features/journey/presentation/redux/saga/get-journey-saga'
import {
  CREATE_JOURNEY_REQUEST,
  GET_JOURNEY_REQUEST,
  CONCLUDE_JOURNEY_REQUEST,
} from '../features/journey/presentation/redux/types/journey-types'
import { concludeJourneySaga } from '../features/journey/presentation/redux/saga/conclude-journey-saga'
import { createCollectionOrderSaga } from '../features/collectionorder/presentation/redux/saga/create-collection-order-saga'
import { getCollectionOrderStatusSaga } from '../features/collectionorder/presentation/redux/saga/get-collection-order-status-saga'
import { CREATE_COLLECTION_ORDER_REQUEST } from '../features/collectionorder/presentation/redux/types/create-collection-order-types'
import { GET_COLLECTION_ORDER_STATUS_REQUEST } from '../features/collectionorder/presentation/redux/types/get-collection-order-status-types'
import { changePasswordSaga } from '../features/user/presentation/redux/saga/change-password-saga'
import { changePasswordResetSaga } from '../features/user/presentation/redux/saga/change-password-reset-saga'
import { generateTokenSaga } from '../features/user/presentation/redux/saga/generate-token-saga'
import { getUserSaga } from '../features/user/presentation/redux/saga/get-user-saga'
import { resetPasswordSaga } from '../features/user/presentation/redux/saga/reset-password-saga'
import { validateTokenSaga } from '../features/user/presentation/redux/saga/validate-token-saga'
import { CHANGE_PASSWORD_REQUEST } from '../features/user/presentation/redux/types/change-password-types'
import { GET_USER_REQUEST } from '../features/user/presentation/redux/types/get-user-types'
import {
  USER_RESET_PASSWORD_REQUEST,
  GENERATE_TOKEN_REQUEST,
  VALIDATE_TOKEN_REQUEST,
  CHANGE_PASSWORD_RESET_REQUEST,
} from '../features/user/presentation/redux/types/reset-password-types'

export function* rootSaga(): Generator {
  return yield all([
    //Auth
    takeLatest<any>(LOGIN_REQUEST, loginSaga),
    takeLatest<any>(REFRESH_JWT_REQUEST, refreshJwtSaga),

    //Journey
    takeLatest<any>(GET_JOURNEY_REQUEST, getJourneySaga),
    takeLatest<any>(CREATE_JOURNEY_REQUEST, createJourneySaga),
    takeLatest<any>(CONCLUDE_JOURNEY_REQUEST, concludeJourneySaga),

    //User
    takeLatest<any>(GET_USER_REQUEST, getUserSaga),
    takeLatest<any>(USER_RESET_PASSWORD_REQUEST, resetPasswordSaga),
    takeLatest<any>(CHANGE_PASSWORD_REQUEST, changePasswordSaga),

    //Reset Password Flow
    takeLatest<any>(GENERATE_TOKEN_REQUEST, generateTokenSaga),
    takeLatest<any>(VALIDATE_TOKEN_REQUEST, validateTokenSaga),
    takeLatest<any>(CHANGE_PASSWORD_RESET_REQUEST, changePasswordResetSaga),

    // CollectionOrder
    takeLatest<any>(CREATE_COLLECTION_ORDER_REQUEST, createCollectionOrderSaga),
    takeLatest<any>(
      GET_COLLECTION_ORDER_STATUS_REQUEST,
      getCollectionOrderStatusSaga,
    ),
  ])
}
